module.exports = __webpack_public_path__ + "img/7.fd893d75.jpg";